<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{
                            transaction_document.document_id ? $t("lang.edit_transaction_document") : $t("lang.add_transaction_document")
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="transaction_document.document_id && transaction_document.document_id > 0"
                            @invoke-method="refresh(true)"
                        ></bc-btn-refresh>
                        <!-- <v-menu left content-class="no-stripe" v-if="transaction_document.document_id && transaction_document.document_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <div v-if="transaction_document.status_id == 27">
                                    <v-list-tile @click="changeStatus({ option_id: 26 })">
                                        <v-list-tile-title>
                                            {{ $t("lang.mark_as_draft") }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </div>
                                <div v-if="transaction_document.status_id == 26 || transaction_document.status_id == 192">
                                    <v-list-tile @click="changeStatus({ option_id: 27 })">
                                        <v-list-tile-title>
                                            {{ $t("lang.mark_as_waiting_for_shipment") }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </div>
                                <template
                                    v-if="
                                        hasPerm('transaction_documents.delete') &&
                                        transaction_document.transaction_document_payments == null &&
                                        transaction_document.status_id == 26
                                    "
                                >
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_transaction_document.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu> -->
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'transaction_documents' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <!-- <bc-transaction-links :items="transaction_document.transaction_links" :object_id="transaction_document.document_id"></bc-transaction-links> -->
                    <v-flex :class="transaction_document.document_id != null ? 'lg12 md12 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="transaction_document.status" class="ribbon ribbon-top-right" :class="`ribbon-${transaction_document.status_class}`">
                                    <span class="ribbon-span">{{ transaction_document.status }}</span>
                                </div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-card-text v-if="transaction_document.transaction_document_payments != null" :class="$bp.smallScreen ? 'pa-0' : null">
                                        <v-card
                                            color="grey lighten-4 mb-2"
                                            elevation="0"
                                            @click="showFeInvoicePayments = !showFeInvoicePayments"
                                            class="underline-on-hover"
                                            style="cursor: pointer"
                                        >
                                            <v-card-title
                                                ><label style="cursor: pointer"
                                                    >Payments Received ({{ transaction_document.transaction_document_payments.length }})</label
                                                ></v-card-title
                                            >
                                        </v-card>
                                        <div :class="{ 'slide-up': !showFeInvoicePayments, 'slide-down': showFeInvoicePayments }">
                                            <v-card v-if="showFeInvoicePayments" class="slide-container" elevation="0" style="background: transparent">
                                                <v-data-table
                                                    :headers="invoice_payment_headers"
                                                    :items="transaction_document.transaction_document_payments"
                                                    :no-data-text="$t('lang.no_results_matching')"
                                                    hide-actions
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <tr class="clickable" @mouseup.left="setupFeInvoicePaymentDialog(props.item)">
                                                            <td>{{ props.item.payment_id }}</td>
                                                            <td>{{ props.item.document_id }}</td>
                                                            <td>{{ props.item.company }}</td>
                                                            <td>{{ props.item.payment_date }}</td>
                                                            <td>{{ props.item.amount }}</td>
                                                            <td>{{ props.item.payment_method }}</td>
                                                            <td>
                                                                <v-chip
                                                                    disabled
                                                                    round
                                                                    text-color="white"
                                                                    class="fs-14 text-center"
                                                                    :color="props.item.status_class"
                                                                >
                                                                    <span style="min-width: 60px">{{ props.item.payment_status }}</span>
                                                                </v-chip>
                                                            </td>
                                                            <td>{{ props.item.reference_number }}</td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <!-- <bc-pagination :page="page" :params="axiosParams" name="invoice_payments"></bc-pagination> -->
                                                <v-divider horizontal></v-divider>
                                            </v-card>
                                        </div>
                                    </v-card-text>
                                    <v-form ref="formTransactionDocument">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            v-if="transaction_document.document_id"
                                                            v-model="transaction_document.document_id"
                                                            :label="$t('lang.order_number')"
                                                            :counter="showCounter(transaction_document.document_id, 'transaction_documents.document_id')"
                                                            :rules="ifValid('transaction_documents.document_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <v-text-field
                                                            v-model="transaction_document.company"
                                                            :label="$t('lang.company')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <bc-autocomplete
                                                            v-model="transaction_document.device_id"
                                                            :label="`${$t('lang.device')} *`"
                                                            :items="devices || []"
                                                            item-value="device_id"
                                                            item-text="public_id"
                                                            :rules="ifValid('transaction_documents.device_id')"
                                                            disabled
                                                            append-icon="lock"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                        <v-flex xs12 sm6>
                                                            <bc-date-picker
                                                                v-model="transaction_document.document_date"
                                                                :label="$t('lang.order_date')"
                                                                :rules="ifValid('transaction_documents.document_date')"
                                                                :disabled="
                                                                    transaction_document.status_id == '26' || transaction_document.status_id == null
                                                                        ? false
                                                                        : true
                                                                "
                                                            ></bc-date-picker>
                                                        </v-flex>
                                                        <v-flex xs12 sm6>
                                                            <bc-date-picker
                                                                v-model="transaction_document.due_date"
                                                                :label="`${$t('lang.expected_delivery_date')} *`"
                                                                :rules="ifValid('transaction_documents.due_date')"
                                                                :disabled="
                                                                    transaction_document.status_id == '26' || transaction_document.status_id == null
                                                                        ? false
                                                                        : true
                                                                "
                                                            ></bc-date-picker>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="transaction_document.shipping_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.delivery_address") }}
                                                                <!-- <v-btn
                                                                    v-if="transaction_document.status_id != 168 && current_user.slug != 'customer'"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('ship_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn> -->
                                                            </h3>
                                                            <div>
                                                                <div v-if="transaction_document.ship_location_label">
                                                                    {{ transaction_document.ship_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ transaction_document.ship_address1 }}
                                                                </div>
                                                                <div v-if="transaction_document.ship_address2 != ''">
                                                                    {{ transaction_document.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ transaction_document.ship_city }}, {{ transaction_document.ship_state }},
                                                                    {{ transaction_document.ship_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ transaction_document.ship_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-textarea
                                                            v-model="transaction_document.comments"
                                                            :label="$t('lang.comments')"
                                                            auto-grow
                                                            rows="1"
                                                            :rules="ifValid('transaction_documents.comments')"
                                                            :disabled="
                                                                transaction_document.status_id == '26' || transaction_document.status_id == null ? false : true
                                                            "
                                                        ></v-textarea>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6 v-if="device.ports != null">
                                                <v-data-table
                                                    v-if="device != null"
                                                    :headers="transaction_doc_headers"
                                                    :items="transaction_document.transaction_document_details || []"
                                                    hide-actions
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <tr>
                                                            <td>
                                                                {{
                                                                    $isSet(props.item.product_name)
                                                                        ? props.item.product_name
                                                                        : device.ports.find((port) => port.product_id == props.item.product_id).product_name
                                                                }}
                                                            </td>
                                                            <td class="text-center">
                                                                {{
                                                                    device.ports.find((port) => port.product_id == props.item.product_id)
                                                                        .user_available_capacity
                                                                }}
                                                            </td>
                                                            <td>
                                                                <v-text-field
                                                                    :disabled="
                                                                        transaction_document.status_id == '26' || transaction_document.status_id == null
                                                                            ? false
                                                                            : true
                                                                    "
                                                                    v-model="props.item.quantity"
                                                                    :rules="ifValid('transaction_document_details.quantity')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-center">
                                                                <v-btn
                                                                    v-if="transaction_document.status_id == '26' || transaction_document.status_id == null"
                                                                    icon
                                                                    @click="removeProductFromTransaction(props.index)"
                                                                    ><v-icon>delete</v-icon></v-btn
                                                                >
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template
                                                        v-if="
                                                            (device.ports && transaction_document.transaction_document_details == null) ||
                                                            (device.ports.filter(
                                                                (port) =>
                                                                    !transaction_document.transaction_document_details.find(
                                                                        (detail) => detail.product_id == port.product_id
                                                                    )
                                                            ).length > 0 &&
                                                                (transaction_document.status_id == '26' || transaction_document.status_id == null))
                                                        "
                                                        v-slot:footer
                                                    >
                                                        <td :colspan="transaction_doc_headers.length - 1">
                                                            <bc-autocomplete
                                                                placeholder="Select Product"
                                                                v-model="selected_product"
                                                                :items="
                                                                    transaction_document.transaction_document_details == null
                                                                        ? device.ports
                                                                        : device.ports.filter(
                                                                              (port) =>
                                                                                  !transaction_document.transaction_document_details.find(
                                                                                      (detail) => detail.product_id == port.product_id
                                                                                  )
                                                                          )
                                                                "
                                                                item-value="product_id"
                                                                item-text="product_name"
                                                            >
                                                            </bc-autocomplete>
                                                        </td>
                                                        <td colspan="1">
                                                            <v-btn color="primary" icon @click="addProductToTransaction()" :disabled="selected_product == ''"
                                                                ><v-icon>add</v-icon></v-btn
                                                            >
                                                        </td>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions
                                v-if="
                                    transaction_document.status_id == 166 ||
                                    transaction_document.status_id == 169 ||
                                    transaction_document.status_id == 192 ||
                                    transaction_document.status_id == 193
                                "
                                class="pa-0 w-100"
                            >
                                <v-alert :value="true" type="warning" style="width: 100%; padding: 12px !important">
                                    {{ $t("lang.transaction_document_locked") }}
                                </v-alert>
                            </v-card-actions>
                            <v-card-actions v-else>
                                <v-spacer></v-spacer>
                                <v-btn flat @mouseup.left="$router.push({ name: 'transaction_documents' })">{{ $t("lang.cancel") }}</v-btn>
                                <v-btn v-if="transaction_document.status_id == '26'" color="error" @click="deleteTransactionDocuments()">Delete Order</v-btn>
                                <v-btn v-if="transaction_document.status_id == null" color="grey" style="color: white" @click="changeStatus(26)">{{
                                    $t("lang.save_as_draft")
                                }}</v-btn>
                                <v-btn v-if="hasPerm('logistics.update') && transaction_document.status_id == '27'" color="warning" @click="changeStatus(26)"
                                    >Recall Order</v-btn
                                >
                                <v-btn
                                    v-if="transaction_document.status_id == '26' || transaction_document.status_id == null"
                                    color="success"
                                    @click="changeStatus(27)"
                                    >{{ $t("lang.submit_order") }}</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <!-- <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector> -->
            <delete-confirmation-dialog
                ref="delete_transaction_document"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_transaction_document')"
                :message="$t('lang.delete_transaction_document_confirm')"
                @onConfirm="deleteTransactionDocuments()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_transaction_document_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteFeInvoiceDetails()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_transaction_document_payments"
                :heading="$t('lang.delete_transaction_document_payment')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteFeInvoicePayments(invoice_payment.payment_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            transaction_document: {
                document_id: null,
                discount_type: "A",
                company_id: null,
                shipping_address_id: null,
            },
            file_name: "",
            dbGetTransactionDocument: _.debounce(this.getTransactionDocument, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            convert_currency: false,
            loading: false,
            selectedDevice: {},
            transaction_doc_headers: [
                { text: this.$t("lang.product"), sortable: false, width: "70%" },
                { text: this.$t("lang.available_capacity"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.order_quantity"), sortable: false, width: "28%" },
                { text: "", sortable: false, width: "2%" },
            ],
            selected_product: "",
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchTransactionDocument", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.transaction_documents) {
                        this.transaction_document = this.assignObj2(data.transaction_documents, this.rules_transaction_documents);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=transaction_document_status&sort_by=2",
                            method: "get",
                            stateProperty: "transaction_document_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "transaction_documents", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchTransactionDocument", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.transaction_documents) {
                        next((vm) => {
                            vm.transaction_document = vm.assignObj2(data.transaction_documents, vm.rules_transaction_documents);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=transaction_document_status&sort_by=2",
                                method: "get",
                                stateProperty: "transaction_document_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "transaction_documents", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_transaction_documents: (state) => state.transaction_documents.rules_transaction_documents,
            transaction_document_status_options: (state) => state.settings.transaction_document_status_options,
            transaction_documents: (state) => state.transaction_documents.transaction_documents,
            selectedTransactionDocument: (state) => state.transaction_documents.selectedTransactionDocument,
            devices: (state) => state.devices.device_options,
            department_options: (state) => state.departments.department_options,
            customer_options: (state) => state.customers.customer_options,
            device: (state) => state.devices.selectedDevice,
            rules_transaction_document_details: (state) => state.transaction_documents.rules_transaction_documents.transaction_document_details,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.transaction_document.company_id);
        },
        filter_devices() {
            this.fetchDevices({ body: { options: 1, company_id: this.transaction_document.company_id } });
        },
    },
    methods: {
        ...mapActions([
            "fetchTransactionDocument",
            "saveTransactionDocument",
            "deleteTransactionDocument",
            "printTransactionDocument",
            "fetchDevices",
            "saveFeInvoice",
            "deleteFeInvoice",
            "printFeInvoice",
            "fetchFeParts",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "fetchDepartments",
            "fetchCustomers",
            "fetchOptions",
            "saveFeInvoicePayment",
            "deleteFeInvoicePayment",
            "fetchProjects",
            "fetchFePart",
            "fetchDevice",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getTransactionDocument(pg_refresh = false) {
            this.startLoader();

            this.fetchTransactionDocument({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.transaction_document) {
                    this.transaction_document = this.assignObj2(data.transaction_document, this.rules_transaction_documents);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printTransactionDocument({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.transaction_document) {
                    if (this.dev_mode) {
                        this.file_name = data.transaction_document.file_name;
                    } else {
                        this.$refs.print.printReport(data.transaction_document.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveTransactionDocuments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formTransactionDocument")) {
                    let body = this.prepForm(this.transaction_document, this.rules_transaction_documents);

                    this.saveTransactionDocument({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.transaction_documents) {
                            this.transaction_document = this.assignObj2(data.transaction_documents, this.rules_transaction_documents);
                            this.toggleModalLoader(false);
                            this.validationOff();
                            this.finishLoader(false);
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(status_id) {
            this.status_loader = true;
            let body = { document_id: `${this.$route.params.id}`, status_id: status_id };

            this.saveTransactionDocument({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.transaction_documents) {
                    this.transaction_document = this.assignObj2(data.transaction_documents, this.rules_transaction_documents);
                    this.status_loader = false;
                }
            });
        },
        deleteTransactionDocuments() {
            this.deleteTransactionDocument({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "transaction_documents" });
                }
                this.toggleModalLoader(false);
            });
        },
        getDevices() {
            this.fetchDevices({ body: { options: 1, company_id: this.transaction_document.company_id } });
        },
        addProductToTransaction() {
            if (this.transaction_document.transaction_document_details == null) this.transaction_document.transaction_document_details = [];
            this.transaction_document.transaction_document_details.push({
                product_id: this.selected_product,
                quantity:
                    Math.sign(this.device.ports.find((port) => port.product_id == this.selected_product).user_available_capacity) == -1
                        ? 0
                        : this.device.ports.find((port) => port.product_id == this.selected_product).user_available_capacity,
            });
            this.selected_product = "";
        },
        removeProductFromTransaction(index) {
            this.transaction_document.transaction_document_details.splice(index, 1);
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchTransactionDocument({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.transaction_documents) {
                        this.transaction_document = this.assignObj2(data.transaction_documents, this.rules_transaction_documents);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.transaction_document.invoice_date == null || force == true) {
                var invoice_date = new Date();
                var due_date = new Date();
                due_date.setDate(invoice_date.getDate() + 30);
                this.transaction_document.invoice_date = invoice_date.toISOString().slice(0, 10);
                this.transaction_document.due_date = due_date.toISOString().slice(0, 10);
            }

            // fetch devices based on the current_user accounts.
            if (this.devices.length == 0 || force == true) {
                let company_ids = [];
                if (this.current_user.accounts) {
                    company_ids = this.current_user.accounts.map((account) => account.company_id);
                }
                this.fetchDevices({ body: { options: 1, company_id: company_ids } });
            }

            if (this.transaction_document_status == 0 || force == true)
                this.fetchOptions({
                    body: { slug: "transaction_document_status", with_trashed: this.transaction_document.document_id ? "1" : "0", options: 1 },
                });

            if (!this.transaction_document.department_id) this.transaction_document.department_id = this.currUserField("department_id");
            if (this.transaction_document.device_id) {
                this.fetchDevice({ id: this.transaction_document.device_id });
            }
            this.loading = false;
            this.finishLoader();
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
